import type { FormValues } from 'src/components/Profile/PersonalDetails/EditPersonalDetails/EditPersonalDetails';
import { useAppConfig } from 'src/modules/appConfig';
import type * as Schema from 'src/types/graphql';

import { useRightsToWork, useUpdateRightsToWork } from '../../data';
import { useUpdateRightsToWorkAnalytics } from '../../useUpdateRightsToWorkAnalytics';
import {
  mapRightsToWorkIntoInputs,
  mergeExistingRightsToWorkWithInput,
} from '../../utils';

export const thailandNationalityId = '10';

export const useResetThRtw = () => {
  const { locale, language, zone, isUnifiedSite } = useAppConfig();
  const { rightsToWork } = useRightsToWork();

  const thaiRightToWork = rightsToWork.find(
    (rtw) => rtw.country.countryCode === 'TH',
  );

  const { updateRightsToWorkAnalytics } = useUpdateRightsToWorkAnalytics();

  const [updateRightsToWork] = useUpdateRightsToWork();

  return (personalDetails: FormValues) => {
    const filteredRightsToWork = rightsToWork.filter(
      (rtw) => rtw.country.countryCode === 'TH',
    );

    if (
      locale === 'TH' &&
      personalDetails.nationality?.id === thailandNationalityId &&
      thaiRightToWork
    ) {
      const updateRightToWorkInput: Schema.UpdateRightToWorkInput = {
        id: filteredRightsToWork[0].id,
        countryCode: 'TH',
        type2: null,
      };
      const updatedRightsToWork = mergeExistingRightsToWorkWithInput(
        mapRightsToWorkIntoInputs(rightsToWork),
        updateRightToWorkInput,
      );

      updateRightsToWork({
        input: { rightsToWork: updatedRightsToWork },
        languageCode: language,
        zone,
        isUnifiedSite,
      });

      updateRightsToWorkAnalytics([
        { actionName: 'EDIT', rtwCountry: thaiRightToWork.country.name },
      ]);
    }
  };
};
